import { h } from 'preact';
import { Button, Stack, styled } from '@lessonnine/design-system.lib';

const ButtonContainer = styled(Stack)`
  position: relative;
`;

/*
  We need to use two component buttons between the primary and secondary ones (primary = focused one, secondarys = the ones around), because our Carousel component
  only keeps the state of the currently selected slide in CSS (or at least, it's the only place where we get to access it),
  so it's not possible to pass along a prop to reflect this, hence we need to show/hide the other button through CSS
 */
const ButtonPrimary = styled(Button)`
  opacity: 0;
  /* Here we select the next sibling of slide-current, because for us the current slide is in the middle (hence it's technically the second one) */
  .slide-current + .slide & {
    opacity: 1;
  }
`;

const ButtonSecondary = styled(Button)`
  bottom: 0;
  display: flex;
  left: 0;
  opacity: 1;
  position: absolute;
  right: 0;
  top: 0;
  /* Here we select the next sibling of slide-current, because for us the current slide is in the middle (hence it's technically the second one) */
  .slide-current + .slide & {
    opacity: 0;
  }
`;

function DesktopCTA({ children, href }) {
  return (
    <ButtonContainer>
      <ButtonPrimary color="secondary-inverse" forwardedAs="a" href={href}>
        {children}
      </ButtonPrimary>
      <ButtonSecondary aria-hidden color="secondary" forwardedAs="a" href={href}>
        {children}
      </ButtonSecondary>
    </ButtonContainer>
  );
}

export { DesktopCTA };
